<template>
  <div>
    <h2 v-html="question" class="question__title mb-10"
        :class="{'question__title-font-default': question.length > 150}" />
    <div class="row">
      <div class="col-12 py-2" v-for="answer in testData.answer_options" :key="answer.id">
        <v-btn class="w-100 justify-start" @click="onClickAnswer(answer)"
               :elevation="0"
               :disabled="loading"
               :color="(selectedAnswer && selectedAnswer.id === answer.id) ? 'primary' : ''"
               :outlined="selectedAnswer && selectedAnswer.id === answer.id"
               large>

          {{answer.title}}
        </v-btn>
      </div>
    </div>
    <div class="row mt-6">
      <div class="col-md-6 mx-auto">
        <v-btn class="w-100 btn-disabled-primary notranslate" @click="sendAnswer"
               :elevation="0"
               :disabled="!selectedAnswer || loading"
               color="primary"
               large>

           Далее
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VerbalLogic',
  computed: {
    ...mapGetters({
      testData: 'testing/testing/testData',
      loading: 'testing/testing/loading',
      selectedAnswer: 'testing/testing/selectedAnswer',
    }),
    question() {
      return `<span>${this.testData.question.question.replace(/\n/g, '<br>')}</span>`;
    },
  },
  methods: {
    ...mapActions({
      sendAnswer: 'testing/testing/sendAnswer',
      setSelectedAnswer: 'testing/testing/setSelectedAnswer',
    }),
    onClickAnswer(answer) {
      this.setSelectedAnswer(answer);
    },
  },
};
</script>
